import { normalize } from 'utils';

const getters = {
  activeItems: state => {
    return state.items.filter(item => item.active);
  },
  filteredItems: state => {
    return state.items.filter(item => {
      let filter = state.filter || {};

      if (filter.active && !item.active) {
          return false;
      }
      if (!!filter.area && item.area.id !== filter.area.id) {
          return false;
      }
      if (!!filter.companyName) {
        let regexp = new RegExp(normalize(filter.companyName), "g");
        if (!normalize(item.companyName).match(regexp)) {
          return false;
        }
      }
      return true;
    });
  }
};

export default getters;



// WEBPACK FOOTER //
// ./client/store/modules/customer/customerGetters.js